import React from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../../shared/contexts/LanguageContext';
import { useSEO } from '../../shared/hooks/useSEO';
import { SEO_CONTENT } from '../../shared/constants/seo';

interface SEOProps {
  page: keyof typeof SEO_CONTENT.en;
  customTitle?: string;
  customDescription?: string;
  customKeywords?: string;
}

export const SEO: React.FC<SEOProps> = ({
  page,
  customTitle,
  customDescription,
  customKeywords
}) => {
  const { language } = useLanguage();
  const location = useLocation();

  const baseUrl = window.location.origin;
  const currentUrl = `${baseUrl}${location.pathname}`;

  const seoData = SEO_CONTENT[language as keyof typeof SEO_CONTENT][page];

  const title = customTitle || seoData.title;
  const description = customDescription || seoData.description;
  const keywords = customKeywords || seoData.keywords;

  useSEO({
    title,
    description,
    keywords,
    url: currentUrl,
    type: seoData.type,
    language: language as 'en' | 'de',
    image: `${baseUrl}/logo.png`, // Default image
  });

  return null; // This component doesn't render anything
};

